import { QueryConstraint, Unsubscribe, where } from "firebase/firestore";
import FirestorePipe from "../utils/pipe";
import Terminal from "../entities/terminais/index";


class TerminaisDB extends FirestorePipe {
    public static readonly colName = "Terminais";
    private readonly idEstab?: string;

    constructor(idEstab?: string) {
        super(TerminaisDB.colName);
        this.idEstab = idEstab;
    }

    public create(data: Omit<Terminal, "id">): Promise<string> {
        return this._create(data);
    }

    public update(id: string, data: Partial<Terminal>): Promise<void> {
        return this._update(id, data);
    }

    public delete(id: string): Promise<void> {
        return this._delete(id);
    }
    public getAll(...params: QueryConstraint[]): Promise<Terminal[]> {
        const constraints = [...params];
        if (this.idEstab) {
            constraints.push(where("estabId", "==", this.idEstab));
        }
        return this._getAll<Terminal>(...constraints);
    }

    public get(id: string): Promise<Terminal | null> {
        return this._get<Terminal>(id);
    }

    public on(
        listener: (data: Terminal[]) => void,
        ...params: QueryConstraint[]
    ): Unsubscribe {
        const constraints = [...params];
        if (this.idEstab) {
            constraints.push(where("estabId", "==", this.idEstab));
        }
        return this._on<Terminal>(listener, ...constraints);
    }

    public onWithError(
        listener: (data: Terminal[]) => void,
        onError: (error: any) => void,
        ...params: QueryConstraint[]
    ): Unsubscribe {
        const constraints = [...params];
        if (this.idEstab) {
            constraints.push(where("estabId", "==", this.idEstab));
        }
        return this._onWithError<Terminal>(listener, onError, ...constraints);
    }
}

export default TerminaisDB;